import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vpn-banner',
  templateUrl: `./vpn-banner.component.html`,
  styleUrls: [`./vpn-banner.component.sass`],
})
export class VpnBannerComponent implements OnInit {
  public isShows: boolean = false;

  ngOnInit(): void {}

  public toggleBanner() {
    this.isShows = !this.isShows;
  }
}
